module.exports = __webpack_public_path__ + "static/media/02_tn.bf11b9d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/02_tn.jpg
// module id = 432
// module chunks = 0